<template>
  <div class="user-detail-vip">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailVipInfo.vips" border style="width: 100%">
        <el-table-column prop="shopName" :label="$t('userDetailVip.shop')" align="center">
        </el-table-column>
        <el-table-column prop="vipId" :label="$t('userDetailVip.vipId')" align="center">
        </el-table-column>
        <el-table-column prop="vipName" :label="$t('userDetailVip.vipName')" align="center">
        </el-table-column>
        <el-table-column prop="vipTel" :label="$t('userDetailVip.vipTel')" align="center">
        </el-table-column>
        <el-table-column prop="sex" :label="$t('userDetailVip.gender')" align="center">
          <template slot-scope="scope">
            {{ scope.row.sex === '0' ? $t('userDetailVip.female') : $t('userDetailVip.male') }}
          </template>
        </el-table-column>
        <el-table-column prop="levelName" :label="$t('userDetailVip.vipLevel')" align="center">
        </el-table-column>
        <el-table-column prop="birthday" :label="$t('userDetailVip.vipBirthday')" align="center">
        </el-table-column>
        <el-table-column prop="startTime" :label="$t('userDetailVip.startTime')" align="center">
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('userDetailVip.endTime')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getVipList } from '@/api/user/userDetailVipApi'

export default {
  name: 'UserDetailVip',
  data() {
    return {
      userDetailVipInfo: {
        vips: [],
        vipTel: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailVipInfo.vipTel = data.tel
      this.loadVipData()
    },
    loadVipData() {
      const params = {
        vipTel: this.userDetailVipInfo.vipTel,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getVipList(params).then(res => {
        this.userDetailVipInfo.vips = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadVipData()
    }
  }
}
</script>

<style scoped>
.user-detail-vip {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>